const fontStack = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;';
export const fonts = {
    heading: fontStack,
    body: fontStack,
};
export const fontSizes = {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '20px',
    xl: '24px',
};
export const fontWeights = {
    standard: '400',
    emphasised: '600',
    heading: '700',
    headingMain: '800',
};
export const lineHeights = {
    none: '0',
    default: '1',
    xs: '18px',
    s: '20px',
    m: '24px',
    l: '32px',
    xl: '36px',
};
export const letterSpacings = {
    normal: '0',
    wide: '0.25px',
};
export const textDecorationThicknesses = {
    s: '1px',
    m: '2px',
    l: '3px',
};
export const textDecorationLines = {
    underline: 'underline',
    none: 'none',
};
//# sourceMappingURL=typography.js.map